import { render, staticRenderFns } from "./YsCamera.vue?vue&type=template&id=089db410&scoped=true"
import script from "./YsCamera.vue?vue&type=script&lang=js"
export * from "./YsCamera.vue?vue&type=script&lang=js"
import style0 from "./YsCamera.vue?vue&type=style&index=0&id=089db410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089db410",
  null
  
)

export default component.exports